import { render, staticRenderFns } from "./QuoteDetailSummary.vue?vue&type=template&id=df3ae0b4&scoped=true"
import script from "./QuoteDetailSummary.vue?vue&type=script&lang=js"
export * from "./QuoteDetailSummary.vue?vue&type=script&lang=js"
import style0 from "./QuoteDetailSummary.vue?vue&type=style&index=0&id=df3ae0b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3ae0b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df3ae0b4')) {
      api.createRecord('df3ae0b4', component.options)
    } else {
      api.reload('df3ae0b4', component.options)
    }
    module.hot.accept("./QuoteDetailSummary.vue?vue&type=template&id=df3ae0b4&scoped=true", function () {
      api.rerender('df3ae0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteDetailSummary.vue"
export default component.exports